// extracted by mini-css-extract-plugin
export default {"atomic":"atomic_atomic__rA7U5","md-block-atomic-wrapper":"atomic_md-block-atomic-wrapper__S-uP2","md-block-atomic-controls":"atomic_md-block-atomic-controls__WmH-N"};